// Angular 2
import { ApplicationRef, enableProdMode, Injector } from '@angular/core';
import { disableDebugTools, enableDebugTools } from '@angular/platform-browser';
import { APP_INITIALIZER } from '@angular/core';
import { ConfigService } from './shared/config/config.service';
import { ServiceLocator } from './shared/serviceLocator.injector';

export function initConfig(config: ConfigService) {
  return () => config.load();
}

export function initServiceLocator(injector: any) {
  return () => {
    ServiceLocator.injector = injector;
  };
}

// Environment Providers
export let PROVIDERS: any[] = [
  {
    provide: APP_INITIALIZER,
    useFactory: initServiceLocator,
    deps: [Injector],
    multi: true,
  },
  // common env directives
];

// Angular debug tools in the dev console
// https://github.com/angular/angular/blob/86405345b781a9dc2438c0fbe3e9409245647019/TOOLS_JS.md
let _decorateModuleRef = <T>(value: T): T => value;

// For Angular CLI, we default to development mode
// Production mode should be enabled through Angular CLI build process
const isProduction = false;

if (isProduction) {
  enableProdMode();

  // Production
  _decorateModuleRef = (modRef: any) => {
    disableDebugTools();

    return modRef;
  };

  PROVIDERS = [
    ...PROVIDERS,
    // custom providers in production
  ];
} else {
  _decorateModuleRef = (modRef: any) => {
    const appRef = modRef.injector.get(ApplicationRef);
    const cmpRef = appRef.components[0];

    enableDebugTools(cmpRef);
    
    // Safely access window.ng
    if ((window as any).ng) {
      let _ng = (window as any).ng;
      (window as any).ng.probe = _ng.probe;
      (window as any).ng.coreTokens = _ng.coreTokens;
    }
    
    return modRef;
  };

  // Development
  PROVIDERS = [
    ...PROVIDERS,
    // custom providers in development
  ];
}

export const decorateModuleRef = _decorateModuleRef;

export const ENV_PROVIDERS = [...PROVIDERS];
